import React from "react";
import { Box, Chip, Button, TextField, Autocomplete } from "@mui/material";
import { DateRangePicker } from "../../../components";

const recognizedOptions = [
  { label: "Все", value: null, sx: { backgroundColor: "#F4F4F5", color: "#71717A" } },
  { label: "Распознано", value: true, sx: { backgroundColor: "#E4FBF1", color: "#1CA673" } },
  { label: "Не распознано", value: false, sx: { backgroundColor: "#FFEAE7", color: "#E85949" } },
];

const inputSx = { "& .MuiOutlinedInput-root": { height: 44 } };

const Filter = ({ filter, onChange, onReset, onSearch }) => {
  const handleTextFieldChange = (event) => {
    onChange({ ...filter, page: 1, [event.target.name]: event.target.value });
  };
  const handleDateRangeChange = ({ start, end }) => {
    onChange({ ...filter, page: 1, datetime_start: start, datetime_end: end });
  };
  const handleRecognizedChange = (event, value) => {
    onChange({ ...filter, page: 1, is_recognized: value?.value ?? null });
  };

  const recognizedValue = recognizedOptions.find((opt) => opt.value === filter.is_recognized) || recognizedOptions[0];

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Autocomplete
          value={recognizedValue}
          options={recognizedOptions}
          fullWidth
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, val) => option.value === val.value}
          renderOption={(props, option) => (
            <li {...props} key={option.label}>
              <Chip label={option.label} size="small" sx={{ fontWeight: 600, fontSize: 12, pointerEvents: "none", ...option.sx }} />
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Статус" className="--floating-label" sx={inputSx} />
          )}
          onChange={handleRecognizedChange}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField
          value={filter.license_plate}
          onChange={handleTextFieldChange}
          label="Госномер"
          variant="outlined"
          name="license_plate"
          className="--floating-label"
          fullWidth
          sx={inputSx}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField
          value={filter.complex_serial}
          onChange={handleTextFieldChange}
          label="Серийный номер комплекса"
          variant="outlined"
          name="complex_serial"
          className="--floating-label"
          fullWidth
          sx={inputSx}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <DateRangePicker
          label="Дата"
          className="--floating-label"
          endDate={filter.datetime_end}
          startDate={filter.datetime_start}
          onChange={handleDateRangeChange}
          sx={inputSx}
        />
      </Box>
      <Button
        color="secondary"
        variant="contained"
        onClick={onReset}
        sx={{ textTransform: "none", whiteSpace: "nowrap", flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500 }}
      >Сбросить</Button>
      <Button
        variant="contained"
        onClick={onSearch}
        sx={{ flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" }}
      >Применить</Button>
    </Box>
  );
};

export default Filter;
